import { INSTA_PAGE_SUMMMARY } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function instaSummary(state=INITIAL_STATE, action) {
 
  switch(action.type) {
    case INSTA_PAGE_SUMMMARY:
     
      // const parsedData = JSON.parse(action.payload.data)
      return { ...state, data: action.payload.data, errors: null };
      
    default:
      return state;
  }
}
